module.exports = __webpack_public_path__ + "static/media/MG.41ea5bf6.png";